module.exports = __webpack_public_path__ + "static/media/logo-stripe-white.45a13d87.png";